import { useNavigate } from 'react-router-dom'
import { Headphones } from 'lucide-react'
import { Avatar } from '../../patterns/Avatar'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function VoiceNowStrip({ channels }: { channels: any[] | null }) {
  const navigate = useNavigate()
  if (!channels || channels.length === 0) return null
  return (
    <div className="rounded-xl bg-card ring-1 ring-border/40 px-4 py-3 flex items-center gap-3 flex-wrap">
      <span className="flex items-center gap-1.5 text-sm font-semibold"><Headphones size={15} className="text-emerald-400" /> In voice now</span>
      {channels.map((c) => (
        <button key={c.channelId} type="button" onClick={() => navigate(c.serverId ? `/servers/${c.serverId}/channels/${c.channelId}` : '/dashboards/callhistory')}
          className="flex items-center gap-2 text-xs px-2.5 py-1.5 rounded-full ring-1 ring-border/60 hover:bg-accent/40 transition">
          <span className="flex -space-x-1.5">
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {c.participants.map((p: any) => (
              <Avatar key={p.id} name={p.name} src={p.avatarUrl} className="h-5 w-5 text-[9px] ring-2 ring-card rounded-full" />
            ))}
          </span>
          <span className="font-medium">{c.name}</span>
          <span className="text-muted-foreground tabular-nums">{c.count}</span>
        </button>
      ))}
    </div>
  )
}
